import React, { useState } from 'react'
import Classes from './AddTaskPopup.module.css'
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';

export default function AddTaskPopup({ handleClose }) {
    const onBoarding = useSelector((state) => state.companyInfo.info);
    const companyId = onBoarding?._id;
    onBoarding.color = '#3E9BFF';

    const handleBgClick = () => {
        // handleClose();
    }

    const handleCardClick = (event) => {
        event.stopPropagation();
    }

    const [selectedClient, setselectedClient] = useState(null);
    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    return (
        <>
            <motion.div
                initial={{ opacity: 0 }} // Animation when component enters
                animate={{ opacity: 1 }}   // Animation when component is open
                exit={{ opacity: 0 }}    // Animation when component exits
                transition={{ duration: 0.2 }}
                className={Classes.popup}
                onClick={handleBgClick}
            >
                <motion.div
                    initial={{ y: -7 }} // Animation when component enters
                    animate={{ y: 0 }}   // Animation when component is open
                    exit={{ y: 7 }}    // Animation when component exits
                    transition={{ duration: 0.25 }}
                    className={Classes.card}
                    onClick={(event) => { handleCardClick(event) }}
                >
                    <div className={Classes.close} onClick={handleClose} >
                        <svg xmlns="http://www.w3.org/2000/svg" height='25px' fill='white' viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg>
                    </div>
                    <div className={Classes.bgPopup} style={{ background: onBoarding?.color }} >
                        <div></div>
                        <h5 className={Classes.title} > Add tasks </h5>
                        <div className={Classes.curveCon} ></div>

                    </div>
                    <div className={Classes.cardCon} >
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Name</label>
                            <input type='text' placeholder='Enter name' className={Classes.inputField} />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Description</label>
                            <textarea
                                rows="4"
                                className={Classes.inputField}
                                placeholder="Start typing..."
                                style={{ resize: "none", height: 'auto', paddingTop: '7px' }}
                            ></textarea>
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Client</label>
                            <select className={Classes.inputField} >
                                {clients.map((val, ind) => {
                                    return <option>{val.email}</option>
                                })
                                }
                            </select>
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Due</label>
                            <input type='date' placeholder='Due date' className={Classes.inputField} />
                        </div>
                        <div className={Classes.flexAlign}>
                            <button type="button" onClick={handleClose} className={Classes.btn1} style={{ border: `1px solid ${onBoarding.color}` }}>
                                <h5 style={{ color: onBoarding.color || "red" }}> Cancel </h5>
                            </button>
                            <button type="button" className={Classes.btn2} style={{ background: onBoarding.color || "black", border: `1px solid ${onBoarding.color}` }}>
                                <h5> Add task </h5>
                            </button>
                        </div>
                    </div>
                </motion.div>
            </motion.div>
        </>
    )
}
